module.exports = __webpack_public_path__ + "img/横板白色黑底.eb45b208.png";